/* Anastasio Home homepage cards: the stone, size and amount buttons switch the variant Add to bag uses,
   the price, and the photograph when the card has one for that option. Add to bag itself is the theme's product-form. */
(function () {
  if (window.ahAutoCards) return;
  window.ahAutoCards = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.aha-opts button[data-variant]');
    if (!b) return;
    var group = b.closest('.aha-opts');
    var card = b.closest('[data-aha-card]');
    group.querySelectorAll('button[data-variant]').forEach(function (x) {
      x.setAttribute('aria-checked', x === b ? 'true' : 'false');
    });
    var name = group.querySelector('.aha-opt');
    if (name) name.textContent = b.dataset.label;
    var price = card.querySelector('.aha-card__price');
    if (price) price.textContent = b.dataset.price;
    var id = card.querySelector('input[name="id"]');
    if (id) id.value = b.dataset.variant;
    var add = card.querySelector('.aha-card__add');
    if (add) {
      var ok = b.dataset.available === 'true';
      add.disabled = !ok;
      if (ok) add.removeAttribute('aria-disabled'); else add.setAttribute('aria-disabled', 'true');
      add.textContent = ok ? 'Add to bag' : 'Sold out';
    }
    if (b.dataset.src) {
      var im = card.querySelector('.aha-card__img');
      if (im) {
        im.srcset = b.dataset.srcset || '';
        im.src = b.dataset.src;
        if (b.dataset.alt) im.alt = b.dataset.alt;
      }
    }
  });
})();
